import Header from '../../components/Header'
import GraficoOceanoAzul from '../../components/GraficoOceanoAzul'
import TabelaOceanoAzul from '../../components/TabelaOceanoAzul'
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { post } from '../../services/api';


function OceanoAzul() {

    const dadosRequisicao = JSON.parse(sessionStorage.getItem('dadosRequisicaoOceanoAzul'));

    const [tipoGrafico, setTipoGrafico] = useState(2); // Vendedores como padrão
    const [carregandoDados, setCarregandoDados] = useState(false);
    const [dadosOceanoAzul, setDadosOceanoAzul] = useState({});

    useEffect(() => {
        getDados();
    }, []);

    useEffect(() => {
        document.body.style.backgroundColor = 'white';

        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    const tipoGraficoChange = (value) => {
        setTipoGrafico(value);
        if (value) {
            getDados(value);
        }
    }

    async function getDados(tipoGrafico) {
        try {
            const [mes, ano] = dadosRequisicao.mesAno.split('-');

            setCarregandoDados(true);

            const requisicao = {
                regiao: dadosRequisicao.regiao,
                vendedor: dadosRequisicao.idVendedor,
                mes: mes,
                ano: ano,
                cargo: dadosRequisicao.cargo,
                tipoGrafico: tipoGrafico ? tipoGrafico : 2,
                visaoRede: dadosRequisicao.visaoRede
            };
            const response = await post('oceanoazul/dados', requisicao);

            setCarregandoDados(false);

            if (response && response[0] && response[0] !== undefined) {
                setDadosOceanoAzul(response);
            } else {
                setDadosOceanoAzul({});
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    return (
        <>
            <Header type="otherPage" />
            <div className="mt-4 mb-4" >
                {(dadosRequisicao.cargo !== 'VENDEDOR') && (
                    <h4 className="font-poppins font-bold text-3xl text-blue-c1 text-center py-4">Oceano Azul</h4>
                )}
                {(dadosRequisicao.cargo != 'VENDEDOR') && (
                    <div className="flex justify-center mb-4 font-extrabold text-gray-c2 text-sm">
                        <label className="mr-4">
                            <input
                                type="radio"
                                value={2}
                                checked={tipoGrafico === 2}
                                onChange={() => tipoGraficoChange(2)}
                            />
                            {'  '}Vendedor
                        </label>
                        <label className="mr-4 ">
                            <input
                                type="radio"
                                value={1}
                                checked={tipoGrafico === 1}
                                onChange={() => tipoGraficoChange(1)}
                            />
                            {'  '}Gerente de Loja
                        </label>
                        {(dadosRequisicao.cargo == 'GERENTE_REGIONAL' || dadosRequisicao.visaoRede) && (
                            <label className="mr-4 ">
                                <input
                                    type="radio"
                                    value={3}
                                    checked={tipoGrafico === 3}
                                    onChange={() => tipoGraficoChange(3)}
                                />
                                {'  '}Gerente Regional
                            </label>
                        )}
                    </div>
                )}
                {carregandoDados && (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <ThreeDots
                            height="5"
                            width="80"
                            radius="9"
                            color="#ff0000"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={true}
                        />
                    </div>
                )}
                <div className="mt-4">
                    {dadosOceanoAzul.length > 0 ? (
                        <>
                            <GraficoOceanoAzul dados={dadosOceanoAzul} cargo={dadosRequisicao.cargo} tipoGrafico={tipoGrafico} />
                            <TabelaOceanoAzul dados={dadosOceanoAzul} cargo={dadosRequisicao.cargo} tipoGrafico={tipoGrafico} />
                        </>
                    ) : (
                        <div className='flex justify-center items-center'>
                            <span className='text-xl'>Sem dados no momento</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

}

export default OceanoAzul